<template>
  <div class="body">
    <div  class="login-top">
      <div id="w-center" >
        <a href="/">
          <img :src="info.logo" alt="">
        </a>
        <p>注册</p>
      </div>
    </div>
    <div class="login-center">
       <el-tabs v-model="activeName" @tab-click="handleClick" :stretch=true class="long-c">
          <el-tab-pane label="个人会员" name="first" class="login-text">
             <Ptzc></Ptzc>
          </el-tab-pane>
          <el-tab-pane label="专家会员" name="second">
            <Zjzc></Zjzc>
          </el-tab-pane>
          <el-tab-pane label="企业会员" name="third">
            <Rjkfs></Rjkfs>
          </el-tab-pane>
        </el-tabs>
    </div>
    <div class="h-40"></div>
    <div class="login-botm">{{info.foot}}</div>
  </div>
</template>
<style scoped>
    body{background: #f5f7fa;}
    .login-center >>> .el-tabs__item {font-size: 16px;font-weight: bold;}
    .login-center >>> .el-tabs__active-bar{width: 71px !important;left: 12%;background-color: #2c5fab}
    .login-center >>> .el-tabs__item:hover{color: #2c5fab;}
    .login-center >>> .el-tabs__item.is-active{color: #2c5fab;}
    .login-center >>> .el-tabs__nav-wrap::after{background-color:#f5f7fa !important;}
    .login-center >>> .el-tabs__nav-wrap::after{background-color:#f5f7fa !important;}
</style>
<script>

import ptzc from '@/components/login/ptzc.vue'
import Zjzc from '@/components/login/zjzc.vue'
import Rjkfs from '@/components/login/rjkfs.vue'

export default{
  data(){
    return {
      info:[],
      activeName: 'first',
      ptzc:'',
    }
  },
  components: {
    'Ptzc': ptzc,
    'Zjzc': Zjzc,
    'Rjkfs': Rjkfs,
  },
  mounted () {
    this.recordapi();
  },
  methods:{
    recordapi(){
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Login/Loginshow",{'userid':userid}).then(res => {
          console.log(res);
          that.info= res;
        });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Register.vue